import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import LinkDemo from './LinkDemo';
import ClientProvider from './client';
export default createDemo(import.meta.url, LinkDemo, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/integrations/routing/demos/link-demo/LinkDemo.tsx",
    "fileName": "LinkDemo.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Link from '@mui/material/Link';\nimport Box from '@mui/material/Box';\n\nexport default function LinkDemo() {\n  return (\n    <Box sx={{ typography: 'body1' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Link href=\"/\">Link</Link>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 10,
        "focusedLines": 1,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Link from '@mui/material/Link';\nimport Box from '@mui/material/Box';\n\nexport default function LinkDemo() {\n  return (\n    <Box sx={{ typography: 'body1' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Link href=\"/\">Link</Link>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 7
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Link"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "href"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "/",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">Link</",
              [
                "span",
                "pl-c1 di-jsx",
                "Link"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 10,
    "focusedLines": 1,
    "collapsible": true,
    "externals": [
      "@mui/material/Link",
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
